import { render, staticRenderFns } from "./clickSwitch.vue?vue&type=template&id=6620f6f2&scoped=true"
import script from "./clickSwitch.vue?vue&type=script&lang=js"
export * from "./clickSwitch.vue?vue&type=script&lang=js"
import style0 from "./clickSwitch.vue?vue&type=style&index=0&id=6620f6f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6620f6f2",
  null
  
)

export default component.exports